import { DeploymentEnvironmentName } from "./types";

export enum EnvironmentVariableKeys {
  BACKEND_API_URL = "BACKEND_API_URL",
}

type Environments = Record<DeploymentEnvironmentName, Record<EnvironmentVariableKeys, string>>;

const environmentConfigs: Environments = {
  [DeploymentEnvironmentName.LOCAL]: {
    BACKEND_API_URL: process.env.NEXT_PUBLIC_BACKEND_API_URL ?? "http://localhost:3999",
  },
  [DeploymentEnvironmentName.DEVELOPMENT]: {
    BACKEND_API_URL: process.env.NEXT_PUBLIC_BACKEND_API_URL ?? "https://api.backend.com",
  },
  [DeploymentEnvironmentName.PRODUCTION]: {
    BACKEND_API_URL: process.env.NEXT_PUBLIC_BACKEND_API_URL ?? "https://api.backend.com",
  },
};

export function getEnvironmentConfig(environmentName: DeploymentEnvironmentName) {
  return environmentConfigs[environmentName] ?? environmentConfigs[DeploymentEnvironmentName.LOCAL];
}

const environmentName =
  (process.env.NEXT_PUBLIC_ENVIRONMENT_NAME as DeploymentEnvironmentName | undefined) ??
  DeploymentEnvironmentName.LOCAL;

export const environmentConfig = getEnvironmentConfig(environmentName);
